import { handleErrorWithSentry } from '@sentry/sveltekit';
import * as Sentry from '@sentry/sveltekit';

const environment = import.meta.env.MODE;
Sentry.init({
  dsn: 'https://1b9524c37d7416d8fae8fe660394b755@o4508890216267776.ingest.de.sentry.io/4509609301966928',
  environment,
  sampleRate: environment === 'development' ? 0 : 0.1,
});

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry();
